export default __webpack_public_path__ + "static/LayoutCheckList-7a8e28ab902ed0250f1d50bba4255bac.svg";